export const VocabSummary = {
    'general' : ['General', 'general'],
    'immunizations' : ['Inmunizaciones', 'Immunizations'],
    'allergies' : ['Alergias', 'Allergies'],
    'hereidatary_history' : ['Antecedentes heredofamiliares', 'Hereidatary history'],
    'pathologic_history' : ['Resumen patológico', 'Pathologic resume'],
    'notes_history' : ['Historial de notas', 'Notes history'],
    'ready_to_begin_general': ["Tu historia.", "Your history."],
    'ready_to_begin_pro': ["Listos para comenzar.", "Ready to begin."],
    'instructions_to_begin_pro' : ["Encuentra a tu paciente buscando su nombre de usuario en la barra.", "Find your patient by searching its username on the search bar."],
    'instructions_to_begin_general' : ["Aqui puedes encontrar tu historia..", "Here you can find your story."],
    'need_help': ['¿Necesitas ayuda? haz click ', 'Need help? click '],
    'here': ['aquí.', 'here.'],
    'error_loading_data': ["Tuvimos un problema recolectando la información solicitada; Por favor intentalo de nuevo.", "We had a problem retrieving the requested data; Please try again."],
    'loading_data' : ['Cargando informacion...', 'Loading data...'],
    '' : ['', ''],
  }
    